import React, { Fragment, useEffect, useRef, useState } from 'react';
import { App, Button, Flex, Form, Modal } from 'antd';
import styled from 'styled-components';

import { useCreateSendDemoEmailMutation } from 'features/user/services';

export const DemoEmail = () => {
    const { notification } = App.useApp();

    const [createSendDemoEmail, { isLoading, isSuccess }] =
        useCreateSendDemoEmailMutation();

    const onSubmit = values => {
        form.validateFields({ validateOnly: true })
            .then(() =>
                createSendDemoEmail({
                    phone: '',
                    name: '',
                    text: '',
                    email: values.email,
                })
            )
            .catch(() => console.warn('error'));
    };

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: 'Успешно',
                description: 'Ваша заявка отправлена.',
                placement: 'top',
            });
        }
    }, [isSuccess]);

    const [form] = Form.useForm();

    const values = Form.useWatch([], form);

    return (
        <Form
            // scrollToFirstError
            form={form}
            onSubmit={() => onSubmit(values)}
            // validateOnMount
            // validateOnBlur
        >
            <EmailInputWrapper>
                <Form.Item
                    label={false}
                    name='email'
                    hasFeedback
                    style={{ marginBottom: 0, flex: '1 1 auto' }}
                    rules={[
                        {
                            pattern: new RegExp(
                                /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
                            ),
                            message: 'Это не похоже на почту',
                        },
                        {
                            required: true,
                            message: 'Укажите почту',
                        },
                    ]}
                >
                    <EmailInput
                        min={2}
                        max={100}
                        placeholder='Оставить почту'
                        size={'large'}
                    />
                </Form.Item>

                <SubmitButton onClick={() => onSubmit(values)}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='42'
                        height='43'
                        viewBox='0 0 42 43'
                        fill='none'
                    >
                        <g clipPath='url(#clip0_1170_246)'>
                            <path
                                d='M16.4908 29.634C16.3931 29.8715 16.3159 30.0107 16.3158 30.2098C16.3158 30.4088 16.3948 30.5997 16.5355 30.7404C16.6762 30.881 16.867 30.96 17.066 30.96C17.2651 30.9599 17.3583 30.9859 17.6715 30.8147C17.9849 30.6435 33.7427 22.8481 33.7427 22.8481C33.9949 22.7244 34.2075 22.5326 34.3562 22.2942C34.5049 22.0559 34.5837 21.7807 34.5839 21.4999C34.584 21.2191 34.5053 20.9439 34.3568 20.7057C34.2083 20.4675 33.9959 20.2757 33.7437 20.1523C33.7437 20.1523 17.8092 12.3685 17.5982 12.2571C17.3872 12.1456 17.2086 12.0955 17.0095 12.0956C16.8105 12.0956 16.6196 12.1748 16.4788 12.3156C16.338 12.4564 16.2588 12.6473 16.2588 12.8464C16.2587 13.0454 16.2923 13.1245 16.4369 13.4184C16.5815 13.7122 20.3598 21.5053 20.3598 21.5053C20.3598 21.5053 16.5885 29.3966 16.4908 29.634Z'
                                stroke='#A3A1BB'
                                strokeWidth='2'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                            />
                        </g>
                        <defs>
                            <clipPath id='clip0_1170_246'>
                                <rect
                                    width='29.3306'
                                    height='29.3306'
                                    fill='white'
                                    transform='translate(41.9907 21.5) rotate(135)'
                                />
                            </clipPath>
                        </defs>
                    </svg>
                </SubmitButton>
            </EmailInputWrapper>
        </Form>
    );
};

const EmailInputWrapper = styled.div`
    display: flex;
    height: 53px;
    max-width: 400px;
    margin: 0 auto;
    background: white;
    border: 2px solid #7c3aed;
    border-radius: 100px;
    padding: 4px;
`;

const EmailInput = styled.input`
    flex: 1;
    border: none;
    padding: 12px 20px;
    font-size: 16px;
    outline: none;
    background: transparent;
    width: 100%;
    border-radius: 20px;
    //overflow: hidden;

    &::placeholder {
        color: #999999;
    }
`;

const SubmitButton = styled.button`
    background: transparent;
    border: none;
    border-radius: 100px;
    width: 42px;
    height: 42px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;
    padding: 0px;
    position: relative;
    top: 0px;
    right: 0px;

    &:hover {
        background: rgba(107, 47, 211, 0.25);
    }
`;

const ActivatorButton = styled(Button)`
    color: white;
    background-color: #6257d2;
    opacity: 0.4;
`;
